// import React from "react";
// import 'normalize.css';


// export default function CompanyPage() {
//   return (
//     <main id="content" className="content">
//       {/* Mission Section */}
//       <section
//         className="vc_row fullheight d-flex flex-wrap align-items-center bg-cover pt-150 pb-150"
//         style={{ backgroundImage: "url(assets/demo/bg/bg-14.jpg)" }}
//         data-parallax="true"
//         data-parallax-options={{ parallaxBG: true }}
//       >
//         <div className="container">
//           <div className="row">
//             <div className="lqd-column col-md-12">
//               <h1 className="text-white text-center mt-0 mb-40">
//                 Our Mission
//               </h1>
//               <p className="text-white font-size-16 lh-185 text-center">
//                 Our mission is to revolutionize financial services and deliver
//                 innovative solutions to help businesses and individuals connect
//                 seamlessly, bridging the gap between technology and finance.
//               </p>
//             </div>
//           </div>
//         </div>
//         {/*  */}

//         <div class="container">
//     <div class="row">
      
//       <div class="lqd-column col-md-3 col-sm-6 text-center">
        
//         <div class="liquid-counter liquid-counter-default text-white text-center">
//           <div class="liquid-counter-element mb-2" data-fittext="true" data-fittext-options='{ "compressor": 0.5, "minFontSize": 70, "maxFontSize": 70 }' data-enable-counter="true" data-counter-options='{"targetNumber":"10+","blurEffect":true}'>
//             <span>10+</span>
//           </div>
//           <span class="liquid-counter-text liquid-text-bottom">Years of Experience</span>
//         </div>
        
//       </div>
      
//       <div class="lqd-column col-md-3 col-sm-6 text-center">
        
//         <div class="liquid-counter liquid-counter-default text-white text-center">
//           <div class="liquid-counter-element mb-2" data-fittext="true" data-fittext-options='{ "compressor": 0.5, "minFontSize": 70, "maxFontSize": 70 }' data-enable-counter="true" data-counter-options='{"targetNumber":"24+","blurEffect":true}'>
//             <span>150+</span>
//           </div>
//           <span class="liquid-counter-text liquid-text-bottom">States and Union Territories</span>
//         </div>
        
//       </div>

//         <div class="lqd-column col-md-3 col-sm-6 text-center">
        
//         <div class="liquid-counter liquid-counter-default text-white text-center">
//           <div class="liquid-counter-element mb-2" data-fittext="true" data-fittext-options='{ "compressor": 0.5, "minFontSize": 70, "maxFontSize": 70 }' data-enable-counter="true" data-counter-options='{"targetNumber":"580+","blurEffect":true}'>
//             <span>580+</span>
//           </div>
//           <span class="liquid-counter-text liquid-text-bottom">Locations</span>
//         </div>
        
//       </div>
      
//       <div class="lqd-column col-md-3 col-sm-6 text-center">
        
//         <div class="liquid-counter liquid-counter-default text-white text-center">
//           <div class="liquid-counter-element mb-2" data-fittext="true" data-fittext-options='{ "compressor": 0.5, "minFontSize": 70, "maxFontSize": 70 }' data-enable-counter="true" data-counter-options='{"targetNumber":"100,00+","blurEffect":true}'>
//             <span>10,000+</span>
//           </div>
//           <span class="liquid-counter-text liquid-text-bottom">Fintech Correspondents</span>
//         </div>
        
//       </div>
      
    
      
//     </div>
//   </div>
//       </section>

//       {/* About Us Section */}
//       <section className="vc_row bg-no-repeat pt-100 pb-100">
//   <div className="container">
//     <div className="row align-items-center">
//       <div className="lqd-column col-md-6">
//         <h2 className="text-center mb-40">About Us</h2>
//         <p className="font-size-16 lh-185">
//         We are India’s first Phygital Fintech logistics company, focused on helping banks, NBFCs, Fintech firms, and insurance companies work more efficiently. Our services make document collection, customer verification, and debt recovery faster and easier.
//       <br></br>
//         Our platform offers complete logistics solutions for online and offline collections, backed by a strong, digitally connected network of Fintech partners and debt collection agencies across India. Experience smooth service and innovation with us!        </p>
//       </div>
//       <div className="lqd-column col-md-6">
//         <img src="assets/img/Company/group.jpg" alt="About Us" className="img-fluid" />
//       </div>
//     </div>
//   </div>
// </section>


//       {/* Our Journey Section */}
//       <section className="vc_row pt-100 pb-100 bg-cover" style={{ backgroundImage: "url(assets/demo/bg/bg-17.jpg)" }}>
//         <div className="container">
//           <div className="row">
//             <div className="lqd-column col-md-12">
//               <h2 className="text-center mb-40">Our Journey</h2>
//               <div className="timeline">
//               {/* <div className="lqd-column col-md-6 d-none d-md-block"> */}
//               <img
//                 src="assets/img/CollectKart/our_journey.png"
//                 alt="Login Visual"
//                 style={{ width: "100%", borderRadius: "8px" }}
//               />
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Our Clients Section */}
//       <section class="vc_row">
//       <div class="container">
//       <div class="row">

//         <div class="lqd-column col-md-12">

//           <div class="carousel-container carousel-nav-left carousel-nav-md carousel-dots-style1">

//             <div  data-lqd-flickity='{"cellAlign":"left","prevNextButtons":false,"buttonsAppendTo":"self","pageDots":false,"groupCells":false,"wrapAround":true,"autoPlay":3000,"pauseAutoPlayOnHover":false}'>

//             <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
//                 <figure class="text-center opacity-02 reset-opacity-onhover">
//                   <img src="assets/img/patner/client-0.png" class="mt-10 w-200" alt="Client"/>
//                 </figure>
//               </div>
//               <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
//                 <figure class="text-center opacity-02 reset-opacity-onhover">
//                   <img src="assets/img/patner/DcbBank1.png" class="mt-10 w-200" alt="Client"/>
//                 </figure>
//               </div>
//               <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
//                 <figure class="text-center opacity-02 reset-opacity-onhover">
//                   <img src="assets/img/patner/client-1.png" class="mt-10 w-200" alt="Client"></img>
//                 </figure>
//               </div>
//               <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
//                 <figure class="text-center opacity-02 reset-opacity-onhover">
//                   <img src="assets/img/patner/client-6.png" class="mt-10 w-200" alt="Client"></img>
//                 </figure>
//               </div>
//               <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
//                 <figure class="text-center opacity-02 reset-opacity-onhover">
//                   <img src="assets/img/patner/Fibe.png" class="mt-10 w-200" alt="Client"></img>
//                 </figure>
//               </div>
//               <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
//                 <figure class="text-center opacity-02 reset-opacity-onhover">
//                   <img src="assets/img/patner/muthoot.png" class="mt-10 w-200" alt="Client"></img>
//                 </figure>
//               </div>
//               <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
//                 <figure class="text-center opacity-02 reset-opacity-onhover">
//                   <img src="assets/img/patner/Suryoday.png" class="mt-10 w-200" alt="Client"></img>
//                 </figure>
//               </div>

//             </div>

//           </div>

//         </div>

//       </div>
//     </div>
    
//   </section>

     
//     </main>
//   );
// }


// ---------------------------------------


import React from "react";
import CountUp from "react-countup";
import "normalize.css";

export default function CompanyPage() {
  return (
    <main id="content" className="content">
      {/* Mission Section */}
      <section
        className="vc_row fullheight d-flex flex-wrap align-items-center bg-cover pt-150 pb-150"
        style={{ backgroundImage: "url(assets/demo/bg/bg-14.jpg)" }}
        data-parallax="true"
        data-parallax-options={{ parallaxBG: true }}
      >
        <div className="container">
          <div className="row">
            <div className="lqd-column col-md-12">
              <h1 className="text-white text-center mt-0 mb-40">Our Mission</h1>
              <p className="text-white font-size-16 lh-185 text-center">
                Our mission is to revolutionize financial services and deliver
                innovative solutions to help businesses and individuals connect
                seamlessly, bridging the gap between technology and finance.
              </p>
            </div>
          </div>
        </div>

        {/* Counters Section */}
        <div className="container">
          <div className="row">
            {/* Counter Item 1 */}
            <div className="lqd-column col-md-3 col-sm-6 text-center">
              <div className="liquid-counter liquid-counter-default text-white text-center">
              <h2 className="mb-2" style={{ color: "#ffffff", fontWeight: "bold", fontSize: "48px"  }}>
                  <CountUp start={0} end={10} duration={2.5} />+
              </h2>

                <span className="liquid-counter-text liquid-text-bottom">
                  Years of Experience
                </span>
              </div>
            </div>

            {/* Counter Item 2 */}
            <div className="lqd-column col-md-3 col-sm-6 text-center">
              <div className="liquid-counter liquid-counter-default text-white text-center">
                <h2 className="mb-2" style={{ color: "#ffffff" , fontWeight: "bold", fontSize: "48px" }}>
                  <CountUp start={0} end={24} duration={2.5} />+
                </h2>
                <span className="liquid-counter-text liquid-text-bottom">
                  States and Union Territories
                </span>
              </div>
            </div>

            {/* Counter Item 3 */}
            <div className="lqd-column col-md-3 col-sm-6 text-center">
              <div className="liquid-counter liquid-counter-default text-white text-center">
                <h2 className="mb-2" style={{ color: "#ffffff", fontWeight: "bold", fontSize: "48px"  }}>
                  <CountUp start={0} end={580} duration={2.5} />+
                </h2>
                <span className="liquid-counter-text liquid-text-bottom">
                  Locations
                </span>
              </div>
            </div>

            {/* Counter Item 4 */}
            <div className="lqd-column col-md-3 col-sm-6 text-center">
              <div className="liquid-counter liquid-counter-default text-white text-center">
                <h2 className="mb-2" style={{ color: "#ffffff" , fontWeight: "bold", fontSize: "48px"  }}>
                  <CountUp start={0} end={10000} duration={2.5} separator="," />+
                </h2>
                <span className="liquid-counter-text liquid-text-bottom">
                  Fintech Correspondents
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section className="vc_row bg-no-repeat pt-100 pb-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="lqd-column col-md-6">
              <h2 className="text-center mb-40">About Us</h2>
              <p className="font-size-16 lh-185">
                We are India’s first Phygital Fintech logistics company, focused
                on helping banks, NBFCs, Fintech firms, and insurance companies
                work more efficiently. Our services make document collection,
                customer verification, and debt recovery faster and easier.
                <br />
                Our platform offers complete logistics solutions for online and
                offline collections, backed by a strong, digitally connected
                network of Fintech partners and debt collection agencies across
                India. Experience smooth service and innovation with us!
              </p>
            </div>
            <div className="lqd-column col-md-6">
              <img
                src="assets/img/Company/group.jpg"
                alt="About Us"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Journey Section */}
      <section
        className="vc_row pt-100 pb-100 bg-cover"
        style={{ backgroundImage: "url(assets/demo/bg/bg-17.jpg)" }}
      >
        <div className="container">
          <div className="row">
            <div className="lqd-column col-md-12">
              <h2 className="text-center mb-40">Our Journey</h2>
              <div className="timeline">
                <img
                  src="assets/img/CollectKart/our_journey.png"
                  alt="Our Journey"
                  style={{ width: "100%", borderRadius: "8px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Clients Section */}
      <section className="vc_row">
        <div className="container">
          <div className="row">
            <div className="lqd-column col-md-12">
              <div className="carousel-container carousel-nav-left carousel-nav-md carousel-dots-style1">
                <div
                  data-lqd-flickity='{"cellAlign":"left","prevNextButtons":false,"buttonsAppendTo":"self","pageDots":false,"groupCells":false,"wrapAround":true,"autoPlay":3000,"pauseAutoPlayOnHover":false}'
                >
                  {/* Clients' Logos */}
                  {[
                    "client-0.png",
                    "DcbBank1.png",
                    "client-1.png",
                    "client-6.png",
                    "Fibe.png",
                    "muthoot.png",
                    "Suryoday.png",
                  ].map((logo, index) => (
                    <div
                      className="lqd-column carousel-item col-md-2 col-sm-3 col-xs-4"
                      key={index}
                    >
                      <figure className="text-center opacity-02 reset-opacity-onhover">
                        <img
                          src={`assets/img/patner/${logo}`}
                          className="mt-10 w-200"
                          alt="Client"
                        />
                      </figure>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
